var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskedbackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 735,
    height: 143,
    viewBox: "0 0 735 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 735,
    height: 143,
    fill: "#171c28",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Masked_Shapes",
    "data-name": "Masked Shapes",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    width: 736,
    height: 143,
    fill: "#f3f2f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Squares_02",
    "data-name": "Squares 02",
    transform: "translate(94 -129)",
    opacity: 0.5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_08",
    "data-name": "Square 08",
    width: 85,
    height: 89,
    transform: "translate(170 269)",
    fill: "#f3f2f6",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_07b",
    "data-name": "Square 07b",
    width: 86,
    height: 89,
    transform: "translate(84 269)",
    fill: "#f3f2f6",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Square_07a",
    "data-name": "Square 07a",
    width: 86,
    height: 89,
    transform: "translate(84 269)",
    fill: "#f3f2f6",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_06",
    "data-name": "Square 06",
    width: 86,
    height: 90,
    transform: "translate(84 179)",
    opacity: 0.046
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_05b",
    "data-name": "Square 05b",
    width: 85,
    height: 89,
    transform: "translate(255 90)",
    fill: "#f3f2f6",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Square_05a",
    "data-name": "Square 05a",
    width: 85,
    height: 89,
    transform: "translate(255 90)",
    fill: "#f3f2f6",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_04",
    "data-name": "Square 04",
    width: 85,
    height: 89,
    transform: "translate(170 90)",
    fill: "#818a96",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_03",
    "data-name": "Square 03",
    width: 85,
    height: 90,
    transform: "translate(170)",
    opacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_02",
    "data-name": "Square 02",
    width: 86,
    height: 90,
    transform: "translate(84)",
    fill: "#f3f2f6",
    opacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_01",
    "data-name": "Square 01",
    width: 84,
    height: 90,
    transform: "translate(0 179)",
    fill: "#f3f2f6",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Squares_02-2",
    "data-name": "Squares 02",
    transform: "translate(773 -129) rotate(90)",
    opacity: 0.5
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_08-2",
    "data-name": "Square 08",
    width: 90,
    height: 89,
    transform: "translate(179 269)",
    fill: "#f3f2f6",
    opacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_07b-2",
    "data-name": "Square 07b",
    width: 90,
    height: 89,
    transform: "translate(89 269)",
    fill: "#f3f2f6",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Square_07a-2",
    "data-name": "Square 07a",
    width: 90,
    height: 89,
    transform: "translate(89 269)",
    fill: "#f3f2f6",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_06-2",
    "data-name": "Square 06",
    width: 90,
    height: 90,
    transform: "translate(89 179)",
    opacity: 0.046
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_05b-2",
    "data-name": "Square 05b",
    width: 89,
    height: 89,
    transform: "translate(269 90)",
    fill: "#f3f2f6",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Square_05a-2",
    "data-name": "Square 05a",
    width: 89,
    height: 89,
    transform: "translate(269 90)",
    fill: "#f3f2f6",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_04-2",
    "data-name": "Square 04",
    width: 90,
    height: 89,
    transform: "translate(179 90)",
    fill: "#818a96",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_03-2",
    "data-name": "Square 03",
    width: 90,
    height: 90,
    transform: "translate(179)",
    opacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_02-2",
    "data-name": "Square 02",
    width: 90,
    height: 90,
    transform: "translate(89)",
    fill: "#f3f2f6",
    opacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Square_01-2",
    "data-name": "Square 01",
    width: 89,
    height: 90,
    transform: "translate(0 179)",
    fill: "#f3f2f6",
    opacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskedbackground);
export default __webpack_public_path__ + "static/media/maskedbackground.345f584721f431f77f1d7ce5a4297123.svg";
export { ForwardRef as ReactComponent };